export const getFirstName = (name?: string | null): string => {
  if (!name || !name.trim()) {
    return 'Upmindy';
  }

  const firstName = name.trim().split(/\s+/)[0];
  return firstName || 'Upmindy';
};
